require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-idb-invest-policy-review.json") })
        }
      }, "path---es-mx-update-idb-invest-policy-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-idb-invest-policy-review!./.cache/json/es-mx-update-idb-invest-policy-review.json
// module id = 930
// module chunks = 231608221292675